import { Link } from 'react-router-dom';
import { mangas, type Manga } from '@/mocks/manga';
import MangaCard from '@/components/feature/MangaCard';

export default function RelatedMangas({ manga }: { manga: Manga }) {
  const related = mangas
    .filter((m) => m.id !== manga.id && m.categoryIds.some((c) => manga.categoryIds.includes(c)))
    .slice(0, 4);

  const fallback = mangas.filter((m) => m.id !== manga.id).slice(0, 4);
  const list = related.length > 0 ? related : fallback;

  return (
    <section className="mt-8" aria-label="猜你喜欢">
      <div className="flex items-end justify-between gap-3">
        <h2 className="font-heading text-lg text-foreground-950 md:text-xl">猜你喜欢</h2>
        <Link
          to="/category"
          className="flex items-center gap-1 whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600"
        >
          更多漫画
          <i className="ri-arrow-right-line" aria-hidden="true" />
        </Link>
      </div>
      <div className="mt-4 grid grid-cols-2 gap-4 sm:grid-cols-4 md:gap-5">
        {list.map((item) => (
          <MangaCard key={item.id} manga={item} />
        ))}
      </div>
    </section>
  );
}